import { render, staticRenderFns } from "./HorizontalNavMenuGroup.vue?vue&type=template&id=2d87d133"
import script from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports